<template>
  <div
    v-if="!isDesktop && isMenuOpen"
    class="fixed left-0 top-0 z-mobile-search-menu h-full w-full overflow-hidden bg-white"
  >
    <LayoutSearchMobileContent />
  </div>
</template>

<script setup lang="ts">
  const searchMenuStore = useSearchMenuStore();
  const { isMenuOpen } = storeToRefs(searchMenuStore);
  const { isDesktop } = useScreen();
</script>
